import { render, staticRenderFns } from "./party-order-detail.vue?vue&type=template&id=ab662570"
import script from "./party-order-detail.vue?vue&type=script&lang=js"
export * from "./party-order-detail.vue?vue&type=script&lang=js"
import style0 from "./party-order-detail.vue?vue&type=style&index=0&id=ab662570&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports